<template>
  <v-row>
    <v-col cols="12">
      <BaseBlock title="Activités de l'officine (4/4)">
        <p class="text-sm-left body-2 font-italic">
          Les informations à renseigner ne le sont qu’à titre indicatif et ne
          sauraient préjuger de l’avis qui sera émis par la commission régionale
          d’agrément.
        </p>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-row>
            <v-col>
              <span class="subtitle-1 text-left font-weight-bold">
                Prévention et Santé publique
              </span>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4">
              <p class="subtitle-1 text-left">
                &#187; Menez-vous des actions de prévention et de dépistage ?
              </p></v-col
            >
            <v-col cols="12" md="6">
              <v-radio-group
                v-model="dossier.preventionDepistage"
                row
                required
                :rules="radioRules"
              >
                <v-radio
                  label="oui"
                  name="preventionDepistage"
                  v-bind:value="true"
                  required
                ></v-radio>
                <v-radio
                  label="non"
                  name="preventionDepistage"
                  v-bind:value="false"
                  required
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row v-if="dossier.preventionDepistage">
            <v-col cols="12" md="8">
              <v-text-field
                v-model="dossier.preventionDepistageThematique"
                label="Si oui, sur quelle(s) thématique(s) ?"
                required
                :rules="textRules"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4">
              <p class="subtitle-1 text-left">
                &#187;Participez-vous à des programmes d’ETP ?
              </p></v-col
            >
            <v-col cols="12" md="6">
              <v-radio-group
                v-model="dossier.ETPProgramme"
                row
                required
                :rules="radioRules"
              >
                <v-radio
                  label="oui"
                  name="ETPProgramme"
                  v-bind:value="true"
                  required
                ></v-radio>
                <v-radio
                  label="non"
                  name="ETPProgramme"
                  v-bind:value="false"
                  required
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row v-if="dossier.ETPProgramme">
            <v-col cols="12" md="8">
              <v-text-field
                v-model="dossier.ETPProgrammeThematique"
                label="Si oui, sur quelle(s) thématique(s) "
                required
                :rules="textRules"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="2">
              <div v-if="dossier.ETPProgramme">
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  :return-value.sync="dateFormationEtp"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      id="agree-calendar"
                      v-model="formatedDate"
                      label="Date de la formation à l'ETP"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      required
                      :rules="textRules"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="dateFormationEtp" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menu = false">
                      Annuler
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.menu.save(dateFormationEtp)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="8"> </v-col>
          </v-row>
          <v-row>
            <v-col cols="5" />
            <v-col cols="1">
              <v-btn
                color="blue"
                class="mr-4 white--text"
                @click="submit"
                :disabled="!valid"
                >Enregistrer et passer à l'étape suivante
                <v-icon>navigate_next</v-icon></v-btn
              >
            </v-col>
          </v-row>
        </v-form>
      </BaseBlock>
    </v-col>
  </v-row>
</template>

<script>
import BaseBlock from "@/components/base/BaseBlock";
import moment from "moment";

export default {
  name: "Partie11",
  props: ["dossier"],
  components: { BaseBlock },
  data: () => ({
    valid: true,
    menu: false,
    dateFormationEtp: null,
    textRules: [v => !!v || "Ce champ est requis"],
    radioRules: [v => v !== null || "Ce champ est requis"],
    numberRules: [
      v =>
        /^-?([0-9]\d*\.?\d*)$/.test(v) ||
        "La superficie doit être composée uniquement de chiffres"
    ]
  }),
  computed: {
    formatedDate() {
      return this.dateFormationEtp
        ? moment(this.dateFormationEtp).format("DD/MM/YYYY")
        : "";
    }
  },
  created() {
    if (this.dossier.dateFormationEtp) {
      let unix_timestamp = this.dossier.dateFormationEtp;
      var date = new Date(unix_timestamp);
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      if (month < 10) month = "0" + month;
      if (day < 10) day = "0" + day;
      this.dateFormationEtp = year + "-" + month + "-" + day;
    }
  },
  methods: {
    async submit() {
      if (this.$refs.form.validate()) {
        this.dossier.dateFormationEtp = this.dateFormationEtp;
        if (!this.dossier.preventionDepistage)
          this.dossier.preventionDepistageThematique = null;
        if (!this.dossier.ETPProgramme)
          this.dossier.ETPProgrammeThematique = null;
        this.$emit("save");
        this.$emit("nextPart");
      }
    }
  }
};
</script>
